module.exports = __webpack_public_path__ + "static/boldare_products-ec0ec33b6ca5f1d2067a7aa7c7891e2f.webm";